import { Link } from 'react-router-dom';
import { siteInfo, stats } from '@/mocks/homepage';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20modern%20abstract%20geometric%20background%20with%20warm%20orange%20and%20dark%20gray%20gradient%2C%20clean%20minimal%20design%20with%20subtle%20dot%20patterns%20and%20flowing%20curves%2C%20tech%20inspired%20atmosphere%2C%20professional%20corporate%20style%2C%20soft%20lighting%20with%20warm%20glowing%20accents%2C%20high%20quality%20abstract%20wallpaper&width=1600&height=900&seq=hero-bg-98tang&orientation=landscape"
        alt="98堂入口导航背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-6">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-xs font-medium border border-primary-400/30 backdrop-blur-sm">
            官方认证 · 安全可靠
          </span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          {siteInfo.fullName}
        </h1>
        <p className="text-lg md:text-xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          {siteInfo.tagline}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#addresses"
            className="px-8 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line mr-2" />
            立即访问
          </a>
          <Link
            to="/category/guide"
            className="px-8 py-3 rounded-lg bg-white/10 hover:bg-white/20 text-white font-medium text-sm backdrop-blur-sm border border-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line mr-2" />
            使用指南
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-14">
          {stats.map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-white/60 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}